import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";
import axios from "axios";
import Swal from "sweetalert2";
const Home = () => {
  const location = useLocation();
  const { path, state } = location;
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null); // To track the menu element

  // Function to toggle the menu open/close state
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  // // Function to close the menu when clicking outside of it
  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsOpen(false); // Close the menu
    }
  };

  useEffect(() => {
    // Add event listener for clicks on the entire document
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener when the component is unmounted
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [isSticky, setIsSticky] = useState(false);
  const [isActive, setIsActive] = useState(false);

  // Toggle function to handle click events

  const [contactForm, setContactForm] = useState({
    name: "",
    email: "",
    phone: "",
    skype: "",
    subject: "",
    websiteName: "",
    message: "",
    agreeToTerms: true
  });

  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setContactForm({
  //     ...contactForm,
  //     [name]: type === 'checkbox' ? checked : value,
  //   });
  // };

  const [errors, setErrors] = useState({}); // Define the errors state

  const [validated, setValidated] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setContactForm((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleSubmit = (e) => {

    e.preventDefault();

    // Simple form validation
    if (!validateForm()) {
      // Swal.fire({
      //   icon: "error",
      //   title: "Warning...",
      //   text: "Please fill out all required fields before submitting.",
      // });
      return;
    }

    // Proceed with form submission if validation is successful
    const contactFormData = new FormData();
    contactFormData.append("Name", contactForm.name);
    contactFormData.append("Email", contactForm.email);
    contactFormData.append("Phone", contactForm.phone);
    contactFormData.append("Skype", contactForm.skype);
    contactFormData.append("Subject", contactForm.subject);
    contactFormData.append("WebsiteName", contactForm.websiteName);
    contactFormData.append("Message", contactForm.message);

    axios
      .post(
        "https://ecoapi.softapproachit.com/api/Article/InsertSoftApproachContact",
        contactFormData
      )
      .then((response) => {
        if (response.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Successful",
            text: "Thank you! We will contact you within 24 hours."
          });

          setContactForm({
            name: "",
            email: "",
            phone: "",
            skype: "",
            subject: "",
            websiteName: "",
            message: "",
            agreeToTerms: true
          });

          setValidated(false);
        } else {
          Swal.fire({
            icon: "success",
            title: "Successful",
            text: "Thank you! We will contact you within 24 hours."
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "success",
          title: "Successful",
          text: "Thank you! We will contact you within 24 hours."
        });
      });
    setContactForm({
      name: "",
      email: "",
      phone: "",
      skype: "",
      subject: "",
      websiteName: "",
      message: "",
      agreeToTerms: true
    });
  };

  const validateForm = () => {
    const form = document.querySelector("form");
    if (form.checkValidity() === false) {
      setValidated(true); // Form has errors
      return false;
    }
    setValidated(false);
    return true;
  };

  const handleClick = () => {
    setIsSticky(!isSticky); // Toggle the sticky state
  };

  const [activeIndex, setActiveIndex] = useState(1);
  const carouselRef = useRef(null); // Reference to OwlCarousel

  const options = {
    loop: true,
    margin: 30,
    nav: false,
    dots: true, // Disable default dots, we'll use custom ones
    items: 1,
    autoplay: true, // Enable autoplay
    autoplayTimeout: 3000, // Set duration for autoplay
    autoplayHoverPause: true, // Pause on hover
    onTranslated: (e) => {
      setActiveIndex(e.item.index + 1); // Update active index when slide changes
    }
  };

  const optionClients = {
    loop: true,
    nav: false,
    dots: true, // Disable default dots, we'll use custom ones
    items: 1,
    slideBy: 1,
    autoplay: true, // Enable autoplay
    autoplayTimeout: 3000, // Set duration for autoplay
    autoplayHoverPause: true // Pause on hover
    // onTranslated: (e) => {
    //   setActiveIndex(e.item.index + 1); // Update active index when slide changes
    // },
  };

  const handleDotClick = (index) => {
    setActiveIndex(index);
    carouselRef.current.to(index - 1); // Go to the selected slide, index starts from 0 in `to()`
  };

  const optionsTest = {
    loop: true,
    margin: 25,
    nav: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 3000,
    center: true, // Enable center mode
    responsive: {
      0: {
        items: 1, // Show 1 item at a time on very small screens (mobile)
        slideBy: 1
      },
      600: {
        items: 2, // Show 2 items at a time on medium screens (tablet)
        slideBy: 1
      },
      1000: {
        items: 4, // Show 4 items at a time on larger screens (desktop)
        slideBy: 1
      }
    }
  };

  return (
    <>


      <>

        {/*start Hero Section  */}
        <section className="home-hero-a" id="home">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 vcenter">
                <div className="hero-content-a">
                  <h1
                    className="h1 mb30"
                    data-aos="fade-in"
                    data-aos-delay={200}
                  >
                    <span className="ree-text rt60">Turn </span>
                    Your Ideas into Launch-Ready Products

                  </h1>
                  <p data-aos="fade-in" data-aos-delay={500}>
                    We build web, mobile, and digital solutions for startups and small businesses. Get from concept to market fast, with technology that scales as you grow.

                  </p>

                </div>
              </div>
              <div className="col-lg-6 vcenter">
                <div className="sol-image m-mt30">
                  <img
                    src="images/sliders/girl-bro.png"
                    alt="web development"
                    className="img-fluid"
                    data-aos="fade-in"
                    data-aos-delay={400}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*hero Section End*/}
        {/*start home-about  */}
        <section className="home-about sec-pad r-bg-a" id="about">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="about-content-home m-mb60 text-center">
                  <span className="sub-heading mb15">
                    About Us
                  </span>
                  <h2 className="mb15">
                    <span className="ree-text rt40">Built</span> for Speed, Designed for Growth
                  </h2>
                  <p>
                    We are a development company dedicated to transforming ideas into reality. From concept to fully developed platforms, we create modern, high-impact digital products. Our approach combines speed with quality, ensuring every feature aligns with your business goals. Whether you're a new venture or an established brand, we turn your vision into reliable, scalable software.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="agency-info-ree mt100">
            <div className="agency-picture">
              <img
                src="images/others/office-view.jpg"
                alt="img"
                className="img-fluid"
              />
            </div>
            <div className="container">
              <div className="row key-and-award">
                <div className="ree-app-st-a flx-end m-order2">
                  <div className="btnctm">
                    <a
                      href="/about-us"
                      className="ree-btn ree-btn-grdt2 mw-80 m-mt30"
                    >
                      Know More Mount Saffron IT{" "}
                      <i className="fas fa-arrow-right fa-btn" />
                    </a>
                  </div>
                </div>
                <div className="ree-app-st-b m-order1">
                  <div className="quick-key-points">
                    <div className="key-highlights">
                      <div className="key-highlt-b">
                        <h3>
                          <span>15</span> <span>+</span>
                        </h3>
                        <p>Project Delivered</p>
                      </div>
                      <div className="key-highlt-b">
                        <h3>
                          <span>5 </span> <span>+</span>
                        </h3>
                        <p>Enterprise Clients</p>
                      </div>
                      <div className="key-highlt-b">
                        <h3>
                          <span>40 </span> <span>+</span>
                        </h3>
                        <p>Experts Team</p>
                      </div>
                      <div className="key-highlt-b">
                        <h3>
                          <span>1 </span> <span></span>
                        </h3>
                        <p>Success Year</p>
                      </div>
                    </div>
                    <div className="agency-info-anim text-center">
                      <div className="animated-logo">
                        <img
                          src="images/banner/mount.png"
                          width={50}
                          alt="Mount Saffron IT logo"
                          className="logo-anim"
                        />
                        <img
                          src="images/banner/app-development.png"
                          alt="Mount Saffron IT logo"
                          className="circle-anim"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {/* <div className="container mt60">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="app-awards owl-carousesl">
                  <div className="award-achivt">
                    <a href="#">
                      <img
                        src="images/brand-logo/top-it.png"
                        alt="top it"
                        className="img-fluid"
                      />
                    </a>
                    <p>Top App Developer Genuine Quality</p>
                  </div>
                  <div className="award-achivt">
                    <a href="#">
                      <img
                        src="images/brand-logo/appfutura-logo.png"
                        alt="top it"
                        className="img-fluid"
                      />
                    </a>
                    <p>Top App Developers by AppFutura</p>
                  </div>
                  <div className="award-achivt">
                    <a href="#">
                      <img
                        src="images/brand-logo/goodfirm-logo.png"
                        alt="top it"
                        className="img-fluid"
                      />
                    </a>
                    <p>Delivering Innovative Tech Solutionsy</p>
                  </div>
                  <div className="award-achivt">
                    <a href="#">
                      <img
                        src="images/brand-logo/clutch-logo.png"
                        alt="top it"
                        className="img-fluid"
                      />
                    </a>
                    <p>Clutch Certified</p>
                  </div>
                  <div className="award-achivt">
                    <a href="#">
                      <img
                        src="images/brand-logo/mobile-app-logo.png"
                        alt="top it"
                        className="img-fluid"
                      />
                    </a>
                    <p>Top Mobile & Web App Development</p>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </section>
        {/*home-about end*/}
        {/*start services*/}
        <section className="r-bg-i sec-pad" id="service">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="sec-heading text-center">
                  <span className="sub-heading mb15">
                    Our Services
                  </span>
                  <h2>
                    What We Can {" "}
                    <span className="ree-text rt40">Build</span>{" "}
                    <span className="ree-text rt40">for</span> You
                  </h2>
                </div>
              </div>
            </div>
            <div className="row mt30 ItServiceRow">
              <div
                className="col-lg-3 col-sm-6 ItService"
                data-aos="fade-up"
                data-aos-delay={1100}
              >
                <div className="ree-card r-bg-c  mt20">
                  <div className="ree-card-img">
                    <img
                      src="images/icons/services/webdev.gif"
                      alt="services"
                    />{" "}
                  </div>
                  <div className="ree-card-content mt40">
                    <h3 className="mb15">
                      <a href="#">Web App Development</a>
                    </h3>
                    <p>
                      We build responsive, fast-loading websites and web apps that look great and work effortlessly to convert your visitors.
                    </p>
                  </div>
                  {/* <div className="ree-card-content-link">
                    <a href="#" className="ree-card-link mt40">
                      Read More <i className="fas fa-arrow-right fa-btn" />
                    </a>
                  </div> */}
                </div>
              </div>
              <div
                className="col-lg-3 col-sm-6 ItService"
                data-aos="fade-up"
                data-aos-delay={700}
              >
                <div className="ree-card r-bg-c  mt20">
                  <div className="ree-card-img">
                    <img src="images/icons/services/mobiledev.gif" alt="services" />{" "}
                  </div>
                  <div className="ree-card-content mt40">
                    <h3 className="mb15">
                      <a href="#">Mobile App Development</a>
                    </h3>
                    <p>
                      Native Android and iOS apps with smooth performance, intuitive navigation, and a focus on user retention.
                    </p>
                  </div>
                  {/* <div className="ree-card-content-link">
                    <a href="#" className="ree-card-link mt40">
                      Read More <i className="fas fa-arrow-right fa-btn" />
                    </a>
                  </div> */}
                </div>
              </div>

              <div
                className="col-lg-3 col-sm-6 ItService"
                data-aos="fade-up"
                data-aos-delay={500}
              >
                <div className="ree-card r-bg-c  mt20">
                  <div className="ree-card-img">
                    <img src="images/icons/services/hybriddev.gif" alt="services" />{" "}
                  </div>
                  <div className="ree-card-content mt40">
                    <h3 className="mb15">
                      <a href="#">Hybrid App Development</a>
                    </h3>
                    <p>
                      Cross-platform solutions (Flutter, React Native) to save time and cost, reaching more users with a single codebase.
                    </p>
                  </div>
                  {/* <div className="ree-card-content-link">
                    <a href="#" className="ree-card-link mt40">
                      Read More <i className="fas fa-arrow-right fa-btn" />
                    </a>
                  </div> */}
                </div>
              </div>
              <div
                className="col-lg-3 col-sm-6 ItService"
                data-aos="fade-up"
                data-aos-delay={900}
              >
                <div className="ree-card r-bg-c  mt20">
                  <div className="ree-card-img">
                    <img src="images/icons/services/uiux.gif" alt="services" />{" "}
                  </div>
                  <div className="ree-card-content mt40">
                    <h3 className="mb15">
                      <a href="#">UI/UX Designing</a>
                    </h3>
                    <p>
                      We create clean, modern interfaces that make complex interactions feel simple. Focused on usability and clarity.
                    </p>
                  </div>
                  {/* <div className="ree-card-content-link">
                    <a href="#" className="ree-card-link mt40">
                      Read More <i className="fas fa-arrow-right fa-btn" />
                    </a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*services end*/}
        <section className="home-about sec-pad r-bg-a sec-pad" id="blog">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="sec-heading text-center">
                  <span className="sub-heading mb15">Our Approach</span>
                  <h2 className="mb15">
                    <span className="ree-text rt40">Simple </span> Process. Fast Results.
                  </h2>
                  <p>
                    Focused on speed + quality + simplicity
                  </p>
                </div>
              </div>
            </div>
            <div className="steps-flow-wrapper pastel">

              {[
                { title: "Understand Your Idea", icon: "fa-lightbulb", color: "#EDE7FF" },
                { title: "Plan & Design", icon: "fa-pencil-ruler", color: "#E0F7FA" },
                { title: "Develop & Test", icon: "fa-code", color: "#FFF3E0" },
                { title: "Launch Quickly", icon: "fa-rocket", color: "#FCE4EC" },
                { title: "Support & Improve", icon: "fa-headset", color: "#E8F5E9" }
              ].map((step, index) => (
                <div className="step-flow-item" key={index}>

                  <div
                    className="step-box pastel-box"
                    style={{ background: step.color }}
                  >
                    <div className="step-icon">
                      <i className={`fas ${step.icon}`}></i>
                    </div>

                    <h6>{step.title}</h6>
                    <span>STEP 0{index + 1}</span>
                  </div>



                </div>
              ))}

            </div>
          </div>
        </section>
        {/*start work*/}

        <section class="r-bg-f sec-pad" id="work">
          <div class="container-fluid">
            <div class="row justify-content-center">
              <div class="col-lg-8 col-sm-8 vcenter text-center">
                <div class="heading-hz-btn">
                  <span class="sub-heading mb15">Our Project</span>
                  <h2 class="w-txt">
                    Real <span class="ree-text rt40">Projects.</span> Real Progress.
                  </h2>
                </div>
              </div>
            </div>
            <div class="row mt60">
              <div class="col-lg-12 vcenter">
                {/* <OwlCarousel
                  className="full-work-app owl-nv owl-carousel"
                  {...optionsTest}
                >
                  <div class="fwb-main-x fwb-a">
                    <div class="work-thumbnails">
                      <a href="#">
                        <img
                          src="images/portfolio/portfolio-1.jpg"
                          alt="portfolio mount saffron"
                          class="img-fluid"
                        />{" "}
                      </a>
                    </div>
                    <div class="work-details">
                      <p class="mb10">UX, UI, Graphic Design</p>
                      <h4>
                        <a href="#">
                          {" "}
                          Furniture ios app kit design development{" "}
                        </a>{" "}
                      </h4>
                    </div>
                  </div>
                  <div class="fwb-main-x fwb-a">
                    <div class="work-thumbnails">
                      <a href="#">
                        {" "}
                        <img
                          src="images/portfolio/portfolio-2.jpg"
                          alt="portfolio mount saffron"
                          class="img-fluid"
                        />{" "}
                      </a>
                    </div>
                    <div class="work-details">
                      <p class="mb10">UX, UI, Graphic Design</p>
                      <h4>
                        <a href="#">Creative business card design service </a>
                      </h4>
                    </div>
                  </div>
                  <div class="fwb-main-x fwb-a">
                    <div class="work-thumbnails">
                      <a href="#">
                        {" "}
                        <img
                          src="images/portfolio/portfolio-3.jpg"
                          alt="portfolio mount saffron"
                          class="img-fluid"
                        />{" "}
                      </a>
                    </div>
                    <div class="work-details">
                      <p class="mb10">UX, UI, Graphic Design</p>
                      <h4>
                        <a href="#">
                          {" "}
                          Furniture ios app kit design development{" "}
                        </a>
                      </h4>
                    </div>
                  </div>
                  <div class="fwb-main-x fwb-a">
                    <div class="work-thumbnails">
                      <a href="#">
                        {" "}
                        <img
                          src="images/portfolio/portfolio-2.jpg"
                          alt="portfolio mount saffron"
                          class="img-fluid"
                        />{" "}
                      </a>
                    </div>
                    <div class="work-details">
                      <p class="mb10">UX, UI, Graphic Design</p>
                      <h4>
                        <a href="#">
                          {" "}
                          Furniture ios app kit design development{" "}
                        </a>
                      </h4>
                    </div>
                  </div>
                  <div class="fwb-main-x fwb-a">
                    <div class="work-thumbnails">
                      <a href="#">
                        {" "}
                        <img
                          src="images/portfolio/portfolio-2.jpg"
                          alt="portfolio mount saffron"
                          class="img-fluid"
                        />{" "}
                      </a>
                    </div>
                    <div class="work-details">
                      <p class="mb10">UX, UI, Graphic Design</p>
                      <h4>
                        <a href="#">Creative business card design service </a>
                      </h4>
                    </div>
                  </div>
                  <div class="fwb-main-x fwb-a">
                    <div class="work-thumbnails">
                      <a href="#">
                        {" "}
                        <img
                          src="images/portfolio/portfolio-3.jpg"
                          alt="portfolio mount saffron"
                          class="img-fluid"
                        />{" "}
                      </a>
                    </div>
                    <div class="work-details">
                      <p class="mb10">UX, UI, Graphic Design</p>
                      <h4>
                        <a href="#">
                          {" "}
                          Furniture ios app kit design development{" "}
                        </a>
                      </h4>
                    </div>
                  </div>
                  <div class="fwb-main-x fwb-a">
                    <div class="work-thumbnails">
                      <a href="#">
                        {" "}
                        <img
                          src="images/portfolio/portfolio-2.jpg"
                          alt="portfolio mount saffron"
                          class="img-fluid"
                        />{" "}
                      </a>
                    </div>
                    <div class="work-details">
                      <p class="mb10">UX, UI, Graphic Design</p>
                      <h4>
                        <a href="#">
                          {" "}
                          Furniture ios app kit design development{" "}
                        </a>
                      </h4>
                    </div>
                  </div>
                </OwlCarousel> */}
                <OwlCarousel
                  className="full-work-app owl-nv owl-carousel"
                  {...optionsTest}
                >
                  <div class="fwb-main-x fwb-a">
                    <div class="work-thumbnails">
                      <a href="#">
                        <img
                          src="images/portfolio/b4a.png"
                          alt="Web Application Project 1"
                          class="img-fluid"
                        />
                      </a>
                    </div>
                    <div class="work-details">
                      <p class="mb10">Web Development</p>
                      <h4>
                        <a href="#"> Air Ticket Booking Website</a>
                      </h4>
                    </div>
                  </div>
                  {/*                 
                                  <div class="fwb-main-x fwb-a">
                                    <div class="work-thumbnails">
                                      <a href="#">
                                        <img
                                          src="images/portfolio/codejido.png"
                                          alt="Web Application Project 2"
                                          class="img-fluid"
                                        />
                                      </a>
                                    </div>
                                    <div class="work-details">
                                      <p class="mb10">Web Design, Frontend Development</p>
                                      <h4>
                                        <a href="#">Education Platform for Kids </a>
                                      </h4>
                                    </div>
                                  </div> */}

                  <div class="fwb-main-x fwb-a">
                    <div class="work-thumbnails">
                      <a href="#">
                        <img
                          src="images/portfolio/y4w.png"
                          alt="Web Application Project 3"
                          class="img-fluid"
                        />
                      </a>
                    </div>
                    <div class="work-details">
                      <p class="mb10">Full-stack Development</p>
                      <h4>
                        <a href="#"> Job Searching Portal </a>
                      </h4>
                    </div>
                  </div>

                  <div class="fwb-main-x fwb-a">
                                    <div class="work-thumbnails">
                                      <a href="#">
                                        <img
                                          src="images/portfolio/toby.png"
                                          alt="Web Application Project 4"
                                          class="img-fluid"
                                        />
                                      </a>
                                    </div>
                                    <div class="work-details">
                                      <p class="mb10">Backend Integration, API </p>
                                      <h4>
                                        <a href="#">Music Streaming Platform</a>
                                      </h4>
                                    </div>
                                  </div>

                  {/* <div class="fwb-main-x fwb-a">
                                    <div class="work-thumbnails">
                                      <a href="#">
                                        <img
                                          src="images/portfolio/softapproach.png"
                                          alt="Web Application Project 5"
                                          class="img-fluid"
                                        />
                                      </a>
                                    </div>
                                    <div class="work-details">
                                      <p class="mb10">UI/UX, Web Development</p>
                                      <h4>
                                        <a href="#">
                                          {" "}
                                          Education Platform{" "}
                                        </a>
                                      </h4>
                                    </div>
                                  </div> */}
                </OwlCarousel>
              </div>
            </div>
            {/* <div class="row justify-content-center text-center mt60">
              <div class="col-lg-10">
                <div class="cta-heading-wide-bt">
                  <h3 class="w-txt">Take a look of our quality work</h3>
                  <a href="/our-work" class="ree-btn  ree-btn-grdt1 mw-80 no-shadows">
                    View All Work <i class="fas fa-arrow-right fa-btn"></i>
                  </a>
                </div>
              </div>
            </div> */}
          </div>
        </section>
        {/*end work*/}
        {/*start technologies*/}
        <section className="r-bg-x zup sec-pad">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="sec-heading text-center">
                  <h2>
                    <span className="ree-text rt40">Technologies</span> We Work
                    With
                  </h2>
                </div>
              </div>
            </div>
            <div className="row justify-content-center mt30">
              <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                <div className="icon-with-title">
                  <a href="javascript:void(0)">
                    <div className="iwt-icon">
                      {" "}
                      <img src="images/Azure.png" alt="Apswiftple" />{" "}
                    </div>
                    <div className="iwt-content">
                      <p>Azure</p>
                    </div>
                  </a>
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                <div className="icon-with-title">
                  <a href="javascript:void(0)">
                    <div className="iwt-icon">
                      {" "}
                      <img
                        src="images/netfinal-removebg-preview.png"
                        alt="Java"
                      />
                    </div>
                    <div className="iwt-content">
                      <p>.Net</p>
                    </div>
                  </a>
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                <div className="icon-with-title">
                  <a href="javascript:void(0)">
                    <div className="iwt-icon">
                      {" "}
                      <img
                        src="images/icons/physics.svg"
                        alt="React Native"
                      />{" "}
                    </div>
                    <div className="iwt-content">
                      <p>React </p>
                    </div>
                  </a>
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                <div className="icon-with-title">
                  <a href="javascript:void(0)">
                    <div className="iwt-icon">
                      {" "}
                      <img src="images/vue.png" style={{ width: "55" }} alt="Flutter" />{" "}
                    </div>
                    <div className="iwt-content">
                      <p>Vue.js</p>
                    </div>
                  </a>
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                <div className="icon-with-title">
                  <a href="javascript:void(0)">
                    <div className="iwt-icon">
                      {" "}
                      <img src="images/AngularLogo.png" alt="Flutter" />{" "}
                    </div>
                    <div className="iwt-content">
                      <p>Angular</p>
                    </div>
                  </a>
                </div>
              </div>

              <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                <div className="icon-with-title">
                  <a href="javascript:void(0)">
                    <div className="iwt-icon">
                      {" "}
                      <img src="images/Aws.png" alt="pwa" />
                    </div>
                    <div className="iwt-content">
                      <p>AWS</p>
                    </div>
                  </a>
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                <div className="icon-with-title">
                  <a href="javascript:void(0)">
                    <div className="iwt-icon">
                      {" "}
                      <img
                        src="images/pthon-removebg-preview.png"
                        alt="python"
                      />{" "}
                    </div>
                    <div className="iwt-content">
                      <p>Python</p>
                    </div>
                  </a>
                </div>
              </div>
              {/* <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                <div className="icon-with-title">
                  <a href="javascript:void(0)">
                    <div className="iwt-icon">
                      {" "}
                      <img src="images/NetCore.png" alt="Java" />
                    </div>
                    <div className="iwt-content">
                      <p>.Net Core</p>
                    </div>
                  </a>
                </div>
              </div> */}
              <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                <div className="icon-with-title">
                  <a href="javascript:void(0)">
                    <div className="iwt-icon">
                      {" "}
                      <img src="images/sql.png" alt="Java" />
                    </div>
                    <div className="iwt-content">
                      <p>SQL</p>
                    </div>
                  </a>
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                <div className="icon-with-title">
                  <a href="javascript:void(0)">
                    <div className="iwt-icon">
                      {" "}
                      <img src="images/icons/android.svg" alt="Android" />{" "}
                    </div>
                    <div className="iwt-content">
                      <p>Android</p>
                    </div>
                  </a>
                </div>
              </div>

              <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                <div className="icon-with-title">
                  <a href="javascript:void(0)">
                    <div className="iwt-icon">
                      {" "}
                      <img src="images/icons/apple.svg" alt="Apple" />{" "}
                    </div>
                    <div className="iwt-content">
                      <p>iOS</p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*end technologies*/}
        {/*start home review*/}
        <section className="r-bg-c sec-pad" id="product">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="heading-review text-center">
                  <div className="row justify-content-center">
                    <div className="col-lg-8 col-sm-8 vcenter text-center">
                      <div className="heading-hz-btn">
                        <span className="sub-heading mb15">Our Product</span>
                        <h2 className="mb50">
  Our <span className="ree-text rt40">Product</span>{" "}
  Delivers <span className="ree-text rt40">Exceptional Results</span>
</h2>
                      </div>
                    </div>
                  </div>

                  {/* Portfolio Cards */}
                  <div className="row mt30 justify-content-center gx-4 gy-4">
                    {[
                      {
                        url: "https://violetsync.com/",
                        name: "VioletSync",
                        desc: "Cloud-first SaaS platform for school management.",
                        image: "images/others/violetsyncpreview.png",
                      },
                      {
                        url: "https://www.softapproachit.com/",
                        name: "Soft Approach IT",
                        desc: "Online & offline tech courses to grow your skills.",
                        image: "images/others/softapproachpreview.png",
                      },
                      {
                        url: "https://www.codejido.com/",
                        name: "CodeJido",
                        desc: "Fun coding platform for kids to learn and create.",
                        image: "images/others/codejidopreview.png",
                      },
                    ].map((site, i) => (
                      <div className="col-lg-4 col-md-6 col-sm-12 product-card-col" key={i}>
                        <a
                          href={site.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: "block",
                            textDecoration: "none",
                            border: "1px solid #e0e0e0",
                            borderRadius: "12px",
                            overflow: "hidden",
                            transition: "transform 0.2s, box-shadow 0.2s",
                            height: "100%",
                          }}
                        >
                          {/* Browser Bar */}
                          <div style={{ background: "#f5f5f5", padding: "8px 12px", display: "flex", alignItems: "center", gap: "6px", borderBottom: "1px solid #e0e0e0" }}>
                            <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#ff5f57", display: "inline-block" }}></span>
                            <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#febc2e", display: "inline-block" }}></span>
                            <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#28c840", display: "inline-block" }}></span>
                          </div>

                          {/* Screenshot */}
                          <div style={{ height: "200px", overflow: "hidden", background: "#eee" }}>
                            <img
                              src={site.image}
                              alt={`${site.name} preview`}
                              style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "top" }}
                            />
                          </div>

                          {/* Card Body */}
                          <div style={{ padding: "16px", background: "#fff", textAlign: "left" }}>
                            <h5 style={{ margin: "0 0 6px", fontWeight: 600, color: "#222" }}>{site.name}</h5>
                            <p style={{ margin: "0 0 10px", fontSize: "16px", color: "#666" }}>{site.desc}</p>
                          </div>
                        </a>
                      </div>
                    ))}
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>

        {/*end home review */}
        {/*download app*/}
        <section class="home-app-block r-bg-x sec-pad" id="why">
          <div class="container">
            <div class="row">
              <div class="col-lg-6 vcenter">
                <div class=" contact-left">
                  <span class="sub-heading mb15 sec-heading pera-block text-center text-lg-left">Why Choose Us</span>
                  <h2 class="pera-block text-center text-lg-left">Startup Mindset. Real Results.</h2>

                  <ul class="why-choose-list">
                    <li>
                      <span class="icon">⚡</span>
                      <div>
                        <strong>Fast Development & Delivery</strong>
                        <p>Get to market before your competitors.</p>
                      </div>
                    </li>
                    <li>
                      <span class="icon">💰</span>
                      <div>
                        <strong>Cost-Effective Solutions</strong>
                        <p>Budget-friendly packages for early-stage businesses.</p>
                      </div>
                    </li>
                    <li>
                      <span class="icon">🔧</span>
                      <div>
                        <strong>Flexible & Easy Collaboration</strong>
                        <p>We adapt to your workflow, not the other way around.</p>
                      </div>
                    </li>
                    <li>
                      <span class="icon">📈</span>
                      <div>
                        <strong>Focus on Business Growth</strong>
                        <p>Every feature is a tool to help you scale.</p>
                      </div>
                    </li>
                    <li>
                      <span class="icon">🤝</span>
                      <div>
                        <strong>Long-Term Support</strong>
                        <p>We ensure your product stays secure, updated, and ready for future growth.</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-lg-6 vcenter">
                <div class="sol-image m-mt30">
                  <img
                    src="images/others/whychooseus.png"
                    alt="our app"
                    class="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/*start contact block*/}
        <section
          className="home-contact pb120"
          data-background="images/others/office.jpg" id="contact"
        >
          <div className="container">
            <div className="row zup flx-end">
              <div className="col-right-a">
                <div className="sec-heading fourc-up-a">
                  <span className="sub-heading mb15 sec-heading pera-block text-center text-lg-left">Contact us</span>
                  <h2 class="pera-block text-center text-lg-left">
                    Let’s Get in <span className="ree-text rt40">Touch</span>
                  </h2>
                </div>
                <div className="home-contact-block">
                  <div className="contact-infos">
                    <div className="c-infot">
                      <span>Phone</span>{" "}
                      <a href="tel:911234567890" style={{ fontSize: "14px" }}>
                        <i className="fas fa-phone-alt" /> 9024821468
                      </a>
                    </div>
                    <div className="c-infot">
                      <span>Email</span>{" "}
                      <a
                        href=""
                        style={{ fontSize: "14px" }}
                      >
                        <i className="fas fa-envelope" />{" "}
                        hr@mountsaffronit.com
                      </a>
                    </div>
                  </div>
                  <div className="row justify-content-flexstart">
                    <div className="col-lg-8">

                      {/* REGISTERED ADDRESS */}
                      <div className="mt60">


                        <div className="loc-icon-nam">
                          <img src="images/icons/india.svg" alt="india" />
                          <p>
                            <span className="rt40 text-white mb20">India</span>
                          </p>
                        </div>
                        <h5 className="text-white ">Registered Address</h5>
                        <p className="">
                          E-24, 3rd Floor, Saraswati Nagar, Near Jaipur International
                          Airport, Jaipur 302017, Rajasthan, India
                        </p>
                      </div>

                      {/* SALES OFFICE ADDRESS */}
                      <div className="mt30">
                        <h5 className="text-white ">Sales Office Address</h5>
                        <p className="">
                          52, Tonk Rd, opposite Jaipur Hospital, Jai Ambey Nagar, Gopal Pura Mode, Jaipur, Rajasthan 302018
                        </p>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div className="col-right-b">
                <div className="form-contact-hom fourc-up-b">
                  <div className="form-block">
                    <div className="form-head">
                      <h3>Please fill in the form below.</h3>
                    </div>
                    <div className="form-body">
                      <form
                        action="#"
                        method="post"
                        name="feedback-form"
                        onSubmit={handleSubmit}
                        noValidate
                        className={validated ? "was-validated" : ""}
                      >
                        <div className="fieldsets row">
                          <div className="col-md-6">
                            <input
                              type="text"
                              placeholder="Full Name"
                              name="name"
                              value={contactForm.name}
                              onChange={handleChange}
                              required
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-6">
                            <input
                              type="email"
                              placeholder="Email Address"
                              name="email"
                              value={contactForm.email}
                              onChange={handleChange}
                              required
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="fieldsets row">
                          <div className="col-md-6">
                            <input
                              type="number"
                              placeholder="Contact Number"
                              name="phone"
                              value={contactForm.phone}
                              onChange={handleChange}
                              required
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-6">
                            <input
                              type="text"
                              placeholder="Skype"
                              name="skype"
                              value={contactForm.skype}
                              onChange={handleChange}
                              required
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="fieldsets row">
                          <div className="col-md-6">
                            <input
                              type="text"
                              placeholder="Subject"
                              name="subject"
                              value={contactForm.subject}
                              onChange={handleChange}
                              required
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-6">
                            <select
                              name="websiteName"
                              value={contactForm.websiteName}
                              onChange={handleChange}
                              required
                              className="form-control"
                            >
                              <option value="">Interested in</option>
                              <option value="Web Design">Web Design</option>
                              <option value="Graphic Design">
                                Graphic Design
                              </option>
                              <option value="App Development">
                                App Development
                              </option>
                              <option value="E-commerce Development">
                                E-commerce Development
                              </option>
                              <option value="Other">Other...</option>
                            </select>
                          </div>
                        </div>
                        <div className="fieldsets">
                          <textarea
                            placeholder="Message"
                            name="message"
                            value={contactForm.message}
                            onChange={handleChange}
                            required
                            className="form-control"
                          />
                        </div>
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customCheck"
                            name="agreeToTerms"
                            checked={contactForm.agreeToTerms}
                            onChange={handleChange}
                            required
                          />
                          <label
                            className="custom-control-label label-f-form"
                            htmlFor="customCheck"
                          >
                            I agree to the{" "}
                            <a href="javascript:void(0)">
                              Terms &amp; Conditions
                            </a>{" "}
                            of MOUNT SAFFRON TECHNOLOGIES AND CONSULTANT PRIVATE LIMITED
                          </label>
                        </div>
                        <div className="fieldsets mt20">
                          <button
                            type="submit"
                            name="submit"
                            className="ree-btn ree-btn-grdt1 w-100"
                          >
                            Send your inquiry{" "}
                            <i className="fas fa-arrow-right fa-btn" />
                          </button>
                        </div>
                        <p className="trm">
                          <i className="fas fa-lock" /> We hate spam, and we
                          respect your privacy.
                        </p>
                      </form>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*start contact block*/}
        {/* start locations */}

        {/* end locations */}
        {/*start footer */}

      </>

      {/* <!-- Header End --> */}

    </>
  );
};

export default Home;
